export const SET_USER = "SET_USER";
export const SET_IDEA = "SET_IDEA";
export const SET_PROJECT = "SET_PROJECT";
export const CLEAR_IDEA = "CLEAR_IDEA";
export const CLEAR_PROJECT = "CLEAR_PROJECT";
